import { ConfigGrupoPerfilEnum } from "enums/config-grupo-perfil.enum";
import { PSIMEnum } from "enums/psim.enum";

export class ConfigPSIM {
    id:number;
    senhaCoacaoObrigatoria: boolean;
    palavraChaveObrigatoria: boolean;
    habilitarPalavraChaveSenhaCoacao: boolean;
    dataAlteracao: Date;
    habilitarChaveVirtual: boolean;
    servidor: string;
    porta:number;
    token: string;
    habilitar: boolean;
    integrarPessoaSemCpf: boolean;
    latitude: string;
    longitude: string;
    accountId: number;
    usuarioPSIM: string;
    senhaPSIM: string;
    sistemaPSIM: PSIMEnum;
    habilitarCadastroUsuarioPessoa: boolean;
    webhookUrl: string;
    webhookToken: string;
    situator: boolean;
    situatorNovaApi: boolean;
    situatorOrSituatorNovaApi: boolean;
    webhookHabilitado:boolean;
    envioChavePsim:boolean;
    emailNotificacaoDesativacao: string;
    habilitarBotaoKeyVisitante: boolean;
    habilitarQrCodeVisitante: boolean;
    configGrupoPerfil: ConfigGrupoPerfilEnum;
}

export class ConfigPsimRequestParams {
  shortVersion: boolean
  webhook: boolean
}
